import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import {
  GridEditDateCell,
  GridEditInputCell,
  GridRenderEditCellParams,
} from '@mui/x-data-grid-pro';
import { useState } from 'react';

import FormDatePicker from '../forms/FormDatePicker';

const InRowCellValidator = (
  props: GridRenderEditCellParams & {
    maxDate?: Date;
    minDate?: Date;
    placement?: 'bottom-start' | 'bottom-end';
  },
) => {
  const { error, maxDate, minDate, placement } = props;

  const [datePickerValue, setDatePickerValue] = useState(props.value);

  const isDateColumn = props.colDef.type === 'date';
  const isDateTimeColumn = props.colDef.type === 'dateTime';

  return (
    <Tooltip
      arrow
      placement={placement || 'bottom'}
      open={!!error}
      title={error}
      slotProps={{
        tooltip: {
          sx: {
            bgcolor: 'error.main',
            color: 'common.white',
          },
        },
        arrow: {
          sx: {
            color: 'error.main',
          },
        },
      }}
    >
      {isDateColumn ? (
        <Box
          component="span"
          sx={{
            backgroundColor: 'grey.200',
            display: 'block',
            height: '100%',
            width: '100%',
          }}
        >
          <FormDatePicker
            error={!!error}
            label=""
            name={props.field}
            placeholder=""
            value={datePickerValue}
            minDate={minDate}
            maxDate={maxDate}
            slotProps={{
              openPickerIcon: { sx: { fontSize: '17px' } },
              openPickerButton: { sx: { p: 0, m: 0, mr: '2px' } },
              textField: {
                sx: {
                  height: '100%',
                  '& .MuiInputAdornment-root': { m: 0 },
                  '& .MuiPickersInputBase-root': { px: 0 },
                  '& .MuiPickersInputBase-sectionsContainer': {
                    fontSize: '14px',
                    justifyContent: 'center',
                  },
                },
                InputProps: { sx: { height: '100%' } },
              },
            }}
            onChange={(value) => {
              setDatePickerValue(value);

              void props.api.setEditCellValue({
                id: props.id,
                field: props.field,
                value,
              });
            }}
          />
        </Box>
      ) : isDateTimeColumn ? (
        <GridEditDateCell {...props} />
      ) : (
        <GridEditInputCell {...props} />
      )}
    </Tooltip>
  );
};

export default InRowCellValidator;
